import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-culture-music', templateUrl: './culture-music.component.html', styleUrls: ['./culture-music.component.scss'] })
export class CultureMusicComponent implements OnInit {

  culturalImages = [
    '/assets/img/quick-links/cultural/1 (1).jpg',
    '/assets/img/quick-links/cultural/1 (2).jpg',
    '/assets/img/quick-links/cultural/1 (3).jpg',
    '/assets/img/quick-links/cultural/1 (4).jpg',
    '/assets/img/quick-links/cultural/1 (5).jpg',
    '/assets/img/quick-links/cultural/1 (6).jpg',
    '/assets/img/quick-links/cultural/1 (7).jpg',
    '/assets/img/quick-links/cultural/1 (8).jpg',
    '/assets/img/quick-links/cultural/1 (9).jpg',
    '/assets/img/quick-links/cultural/1 (10).jpg',
    '/assets/img/quick-links/cultural/1 (11).jpg',
    '/assets/img/quick-links/cultural/1 (12).jpg',
    '/assets/img/quick-links/cultural/1 (13).jpg',
    '/assets/img/quick-links/cultural/1 (14).jpg',
    '/assets/img/quick-links/cultural/1 (15).jpg',
    '/assets/img/quick-links/cultural/1 (16).jpg',
    '/assets/img/quick-links/cultural/1 (17).jpg',
    '/assets/img/quick-links/cultural/1 (18).jpg',
    '/assets/img/quick-links/cultural/1 (19).jpg',
    '/assets/img/quick-links/cultural/1 (20).jpg',
    '/assets/img/quick-links/cultural/1 (21).jpg',
    '/assets/img/quick-links/cultural/1 (22).jpg',
    '/assets/img/quick-links/cultural/1 (23).jpg',
    '/assets/img/quick-links/cultural/1 (24).jpg',
    '/assets/img/quick-links/cultural/1 (25).jpg',
  ];

  constructor() { }
  ngOnInit(): void { }
}
